import React from 'react';
import type { PublicShareItem } from '../lib/types';
import { ShareFilenameLabel } from './share-viewer-shared';

export function VideoView(props: { item: PublicShareItem }): React.JSX.Element {
  return (
    <div className="flex w-full flex-1 items-center justify-center p-6 md:p-10">
      <div className="w-full max-w-4xl">
        <div className="overflow-hidden rounded-lg border border-[#1f1f1f] bg-black shadow-[0_1px_3px_0_rgba(0,0,0,0.08)]">
          <video
            data-testid="share-preview-video"
            className="aspect-video w-full bg-black"
            src={props.item.content_url}
            preload="metadata"
            controls
            playsInline
          >
            Your browser does not support video playback.
          </video>
        </div>

        <div className="mt-3 flex min-w-0 justify-center text-[13px] text-[#8a8a8a]">
          <ShareFilenameLabel
            name={props.item.display_name}
            textClassName="text-[13px] text-[#8a8a8a]"
          />
        </div>
      </div>
    </div>
  );
}
